unable to read source [project]/packages/shared/src/studio/session.ts